import Services from "../Service";

class SystemService extends Services{
    constructor(){
        super()
        this.resource = 'system'
    }

    async getSystemProps(){
        const requestUrl = `${this.resource}/system-props`
        return await this.getAPI(requestUrl)
    }

    async getFiliais(){
        const requestUrl = `${this.resource}/filiais`
        return await this.getAPI(requestUrl)
    }
}

export default new SystemService()
